import $ from './jquery.slim.min.js';
import { v4 as uuidv4 } from 'uuid';
import Pristine from 'pristinejs';
import { setupStateFields } from './populate_fields';
const pristineCache = {};
import { triggerCheckoutFailedEvent } from "./triggerCheckoutFailedEvent";

let billingUseShipping = true;

const pristineConfig = {
    classTo: 'form-group',
    errorClass: 'checkout-invalid-field',
    successClass: 'checkout-valid-field',
    errorTextParent: 'form-group',
    errorTextTag: 'div',
    errorTextClass: 'checkout-validation-help-text'
}

Pristine.addValidator("required-billing", function(value) {
    // here `this` refers to the respective input element
    //return parseInt(param1) <= value && value <= parseInt(param2)
    if (billingUseShipping) {
      return true;
    }
    return value.length
}, "This field is required", 5, false);


Pristine.addValidator("required-combo-credit", function(value) {
    // here `this` refers to the respective input element
    //return parseInt(param1) <= value && value <= parseInt(param2)
    let comboMode = $(document).find('input[name="combo_mode"]:checked').val();

    if (comboMode === undefined) {
      comboMode = $(document).find('input[name="combo_mode"]').val();
    }

    if (comboMode !== 'credit') {
      return true;
    }
    return value.length
}, "This field is required", 5, false);



function setupUseBillingAddress() {
  $("[name='billing_use_shipping']").on("click", (e) => {

    billingUseShipping = e.target.value === "true";

    if (billingUseShipping) {
      $('.checkout-use-billing-address').removeClass("checkout-use-billing-address");
    } else {
      $(e.target).closest("form").addClass("checkout-use-billing-address");
    }

  });
}



function makeFieldRequired(ppf, fieldName, attribute='data-pristine-required', val = 1) {
  const selector = `input[name='${fieldName}'], select[name='${fieldName}']`;
  const elements = $(ppf).find(selector).toArray();
  elements.forEach(x => x.setAttribute(attribute, val));
}

export function setupValidation() {
  setupPaypalFormValidation();
  setupComboValidation();
}


function setupPaypalFormValidation() {
  const paypalForms = Array.from(document.getElementsByClassName("checkout-paypal-form"));
  paypalForms.forEach(ppf => {
    makeFieldRequired(ppf, "paypal_checkout_country");
    const formUUID = uuidv4();
    $(ppf).data({"pristine-uuid": formUUID });
    pristineCache[formUUID] = new Pristine(ppf, pristineConfig);
  });
}



function setupComboValidation() {
  const ccFields = ["email", "shipping_first_name", "shipping_last_name","shipping_address1","shipping_city", "shipping_state", "shipping_postal_code", "shipping_country","paypal_checkout_country", "stripe_checkout_country"];
  const billingFields = ["billing_first_name", "billing_last_name", "billing_address1", "billing_city", "billing_state", "billing_postal_code", "billing_country"];
  const ccNumberFields = ["cc_number", "cc_exp_month", "cc_exp_year","cc_cvv"];


  let validationForms = Array.from(document.getElementsByClassName("checkout-combo-form"));



  validationForms.forEach(ppf => {
    const formUUID = uuidv4();
    const oldFields = $(ppf).find("[data-pristine-required-billing]").toArray();

    //makeFieldRequired(ppf, "combo_mode");
    ccFields.forEach(x => makeFieldRequired(ppf, x));
    billingFields.forEach(x => makeFieldRequired(ppf, x, "data-pristine-required-billing"));
    ccNumberFields.forEach(x => makeFieldRequired(ppf, x, "data-pristine-required-combo-credit"));



    $(ppf).data({"pristine-uuid": formUUID });
    pristineCache[formUUID] = new Pristine(ppf, pristineConfig);

    (function(pc, uu) {
      $(document).on("change", 'input[name="combo_mode"]', (e) => {
        pc[uu].reset();
        const form = $(e.currentTarget).closest("form");
        ["checkout-combo-credit", "checkout-combo-paypal", "checkout-combo-klarna", "checkout-combo-ideal", "checkout-combo-none", "checkout-combo-bancontact"].forEach(x => {
          $(form).removeClass(x);
        });

        let comboMode = $(form).find('input[name="combo_mode"]:checked').val() || "none";
        $(form).addClass(`checkout-combo-${comboMode}`);
      });
    })(pristineCache, formUUID);

    let comboMode = $(ppf).find('input[name="combo_mode"]:checked').val() || "none";
    $(ppf).addClass(`checkout-combo-${comboMode}`);



  });



}

function setupCreditCardFormValidation() {
  const ccFields = ["email", "shipping_first_name", "shipping_last_name","shipping_address1","shipping_city", "shipping_state", "shipping_postal_code", "shipping_country","cc_number", "cc_exp_month", "cc_exp_year","cc_cvv","paypal_checkout_country", "stripe_checkout_country"];
  const billingFields = ["billing_first_name", "billing_last_name", "billing_address1", "billing_city", "billing_state", "billing_postal_code", "billing_country"];

  let validationForms = Array.from(document.getElementsByClassName("checkout-credit-card-form"));

  validationForms.forEach(ppf => {

    ccFields.forEach(x => makeFieldRequired(ppf, x));
    billingFields.forEach(x => makeFieldRequired(ppf, x, "data-pristine-required-billing"));


    const formUUID = uuidv4();
    $(ppf).data({"pristine-uuid": formUUID });
    pristineCache[formUUID] = new Pristine(ppf, pristineConfig);
  });
}


function setupFormHandlers(settings) {

  $(document).on("click", ".checkout-submit-paypal", (e) => {
    const formUUID = $(e.currentTarget).closest("form").data("pristine-uuid");
    e.preventDefault();
    const valid = pristineCache[formUUID].validate();
    if (valid) {
      settings.paypalSubmitHandler(e);
    } else {
      triggerCheckoutFailedEvent();
    }
    return false;
  });


  $(document).on("click", ".checkout-submit-credit-card", (e) => {
      const formUUID = $(e.currentTarget).closest("form").data("pristine-uuid");
      e.preventDefault();
      const valid = pristineCache[formUUID].validate();
      if (valid) {
        settings.creditCardFormHandler(e);
      } else {
        triggerCheckoutFailedEvent();
      }
      return false;
  });

  $(document).on("click", ".checkout-submit-combo", (e) => {
      const formUUID = $(e.currentTarget).closest("form").data("pristine-uuid");
      e.preventDefault();
      const valid = pristineCache[formUUID].validate();
      if (valid) {
        settings.comboHandler(e);
      } else {
        triggerCheckoutFailedEvent();
      }
      return false;
  });




}

function setupChangeCountryHandler(changeCountryHandler) {
  $('[name="billing_country"],[name="shipping_country"],[name="paypal_checkout_country"],[name="stripe_checkout_country"]').on("change", e => {
    setCountry(e.target.value);
    changeCountryHandler(e);
  });
}


function setCountry(country) {
  setupStateFields(country);
  const selects = $('[name="billing_country"],[name="shipping_country"],[name="paypal_checkout_country"],[name="stripe_checkout_country"]');
  for (let i = 0; i < selects.length; i++) {
    $(selects[i]).val(country);
  }
}

export default function(settings) {
  setupUseBillingAddress();
  setupCreditCardFormValidation();
  setupValidation();
  setupChangeCountryHandler(settings.changeCountryHandler)
  setupFormHandlers(settings);
  setCountry(settings.shippingZone);
}
